import { useDispatch, useSelector } from 'react-redux';
import { CONTENT_GROUP_ACTION, CONTENT_GROUP_DELETE, CONTENT_GROUP_MESSAGE, userConstants } from '../../constants';
import { alertActions, content_groupActions } from '../../actions';
import { DismissablePopup } from '../popup';

const CardDeletePopup = ({}) => {
    const dispatch = useDispatch();
    const { isOpen, workspace_id, content_group_id } = useSelector(state => state.card_delete_popup)

    const handleClose = () => {
        dispatch({ type: CONTENT_GROUP_DELETE.CLOSE_CARD_DELETE_MODAL })
    }

    const handleDeleteCard = () => {
        const onSuccess = (response) => {
            dispatch({
                        type: userConstants.DESTROYED_CONTENTGROUP,
                        payload: response
                      })
            dispatch(alertActions.success(userConstants.DELETE_CONTENTGROUP));
            dispatch({ type: userConstants.ADD_DELETED_CONTENTGROUP, payload: { data: response.data.data } })


            dispatch({type: CONTENT_GROUP_ACTION.REMOVE_MINIMIZED_CARD, payload:  response.data.data.id })
            handleClose();
        }

        const onError = (response) => {
            dispatch(alertActions.error(response.data.error));
        }

        const params = {
            workspace_id,
            content_group_id,
            onSuccess,
            onError
        };

        dispatch(content_groupActions.deleteContentGroup(params));
    }


    if (!isOpen) {
        return null;
    }


    return <DismissablePopup 
                title={ CONTENT_GROUP_MESSAGE.CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_TITLE }
                confirmText={ CONTENT_GROUP_MESSAGE.CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_CONFIRM_TEXT }
                message={ CONTENT_GROUP_MESSAGE.CONTENT_GROUP_MOVE_TO_RECYCLE_BIN_MESSAGE }
                onClose={handleClose}
                onConfirm={handleDeleteCard}
                show={isOpen}
            />
};

export { CardDeletePopup };